export type UsageEventName = 'page_view' | 'mutation' | 'collaborator_active';

interface UsageEventPayload {
  appId: string;
  event: UsageEventName;
  quantity: number;
  timestamp: string;
}

const usageTrackerUrl = import.meta.env.VITE_USAGE_TRACKER_URL;

export function resolveTenantAppId(explicitAppId?: string): string {
  if (explicitAppId) {
    return explicitAppId;
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }

  return 'unknown-tenant';
}

export async function emitUsageEvent(event: Omit<UsageEventPayload, 'timestamp'>): Promise<void> {
  if (!usageTrackerUrl) {
    return;
  }

  const payload: UsageEventPayload = {
    ...event,
    quantity: Number.isFinite(event.quantity) ? Math.max(0, event.quantity) : 0,
    timestamp: new Date().toISOString(),
  };

  try {
    await fetch(`${usageTrackerUrl.replace(/\/+$/, '')}/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (error) {
    console.warn('Unable to emit usage event', error);
  }
}
